import { LoginData } from '../models/login.model';
import { PendingOrder, PendingOrderPanelItem } from '../models/pending-order.model';
import { User } from '../models/user.model';

export function parsePendingOrderPayloadProductUuid(payload: string): string | null {
  try {
    const parsed = JSON.parse(payload);
    const first = Array.isArray(parsed) ? parsed[0] : parsed;
    return first?.product?.uuid ?? null;
  } catch {
    return null;
  }
}

export function resolvePendingOrderProductName(order: PendingOrder): string {
  if (order.product?.name) {
    return order.product.name;
  }

  const productUuid =
    order.product?.uuid ?? parsePendingOrderPayloadProductUuid(order.payload);

  return productUuid ?? '-';
}

export function mapPendingOrderToPanelItem(order: PendingOrder): PendingOrderPanelItem {
  return {
    companyOrderControlUuid: order.companyOrderControlUuid,
    orderDate: order.createdAt,
    productName: resolvePendingOrderProductName(order),
    quantity: order.quantity,
    token: order.token,
  };
}

export function resolvePendingOrdersDocument(
  user: User | null | undefined,
  loginData: LoginData | null | undefined
): string | null {
  const document = user?.document?.trim() || loginData?.document?.trim();
  return document || null;
}

export function getPendingOrdersSortParams(sortKey: string): {
  sortField: string;
  sortDirection: 'asc' | 'desc';
} {
  return sortKey === 'date-oldest'
    ? { sortField: 'createdAt', sortDirection: 'asc' }
    : { sortField: 'createdAt', sortDirection: 'desc' };
}

export function hasComplementaryDataAction(order: PendingOrder): boolean {
  return (order.actions ?? []).some(
    action => action.status === 'COMPLEMENTARY_DATA'
  );
}

export function filterPendingOrdersForDisplay(
  orders: PendingOrder[]
): PendingOrder[] {
  return orders.filter(order => !hasComplementaryDataAction(order));
}
